import getNative from "./_getNative.js";
import root from "./_root.js";
var Set = getNative(root, "Set");
export {
  Set as default
};
//# sourceMappingURL=_Set.js.map
